const BookingReport = () => {
  return (
    <div>
      <h1 className="text-xl font-bold">Booking Report</h1>
      <p>Report content will come here...</p>
    </div>
  );
};

export default BookingReport;